import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="border-b border-steelLine bg-steel px-4 py-8 sm:py-10" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="plsilzwt0s74">
        <h2 className="text-center text-xl text-gold sm:text-3xl" data-id="element-20" data-mp="avuzvzhn8upb">🎁 5 Exclusive Bonuses Included</h2>
        <ul className="mt-4 grid gap-2.5 md:grid-cols-2" data-id="element-21" data-mp="ft4o5btar0bk">
          {bonuses.map((bonus, index) => <li key={bonus.title} className={`flex h-full flex-col rounded-md border border-gold/40 bg-charcoal p-3.5 ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-22" data-mp="1tbzdm1byu68" data-mpi={index}>
              <h3 className="text-sm text-gold sm:text-base" data-id="element-23" data-mp="3o3y5xt96h484">{bonus.title}</h3>
              <p className="mt-1.5 text-sm font-medium leading-snug text-lightGray" data-id="element-24" data-mp="3t0ybm32484yp">{bonus.body}</p>
              <p className="mt-auto pt-2 font-display text-xs font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-25" data-mp="1mb1o9nkrj3f1">
                {bonus.close}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}